import React from "react";
import {
  BsInstagram,
  BsYoutube,
  BsFacebook,
  BsPinterest,
  BsSnapchat,
  BsTwitch,
  BsSpotify,
} from "react-icons/bs";
import { IoLogoTiktok, IoMailOutline } from "react-icons/io5";
import { FaAmazon, FaLinkedinIn } from "react-icons/fa";
import { MdOutlinePodcasts } from "react-icons/md";
import { HiLink } from "react-icons/hi";

/** Same X glyph as ActiveSocialLinks / IntegrationPlatforms. */
function TwitterXIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
  );
}

/** Match TemplateSections / StaticComponent / ActiveSocialLinks icons. */
function resolveFollowerPlatformIcon(
  platform: string,
): React.ElementType | null {
  const n = String(platform || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  if (!n) return null;
  if (n.includes("insta")) return BsInstagram;
  if (n.includes("tiktok")) return IoLogoTiktok;
  if (n.includes("you")) return BsYoutube;
  if (n.includes("twitter") || n === "x") return TwitterXIcon;
  if (n.includes("linkedin")) return FaLinkedinIn;
  if (n.includes("facebook") || n === "fb") return BsFacebook;
  if (n.includes("pinterest") || n === "pin") return BsPinterest;
  if (n.includes("snap")) return BsSnapchat;
  if (n.includes("twitch")) return BsTwitch;
  if (n.includes("spotify")) return BsSpotify;
  if (n.includes("amazon")) return FaAmazon;
  if (n.includes("mail") || n.includes("newsletter") || n.includes("email")) {
    return IoMailOutline;
  }
  if (n.includes("podcast") || n.includes("applepodcast")) {
    return MdOutlinePodcasts;
  }
  return HiLink;
}

/** Platform glyph for Follower Counts — system social icons, not emoji. */
export function SchemaFollowerPlatformIcon({
  platform,
  className = "mte-schema-follower-ic",
}: {
  platform: string;
  className?: string;
}) {
  const Icon = resolveFollowerPlatformIcon(platform);
  if (!Icon) return null;
  return <Icon className={className} aria-hidden />;
}
